import { Offcanvas } from "react-bootstrap";
import React, { useEffect } from "react";
import { useState } from "react";
import "./filter.css";
import { format } from "date-fns";
import DateRangeComponent from "../AllianceManager/LicenseRequestDetails/DateRangeComponent";
import { toast } from "react-toastify";

const ReferralPartnerFilter = ({
  show,
  onHide,
  setFilters,
  setPage,
  filters,
  showDuedateRange,
  showReqDateRange,
  setShowReqDateRange,
  setShowDuedateRange,
}) => {
  const [filtersData, setFilterData] = useState(filters);

  const [openDueDateCalendar, setOpenDueDateCalendar] = useState(false);

  const applyFilter = () => {
    const {
      name,
      email,
      mobile_no,
      dateSubmit,
    } = filtersData;
    if (
      name ||
      email ||
      mobile_no ||
      dateSubmit
    ) {
        let createdDate = `${format(
            filtersData.dueDateRange[0].startDate,
            "dd-MM-yyyy"
        )} to ${format(filtersData.dueDateRange[0].endDate, "dd-MM-yyyy")}`;

      let from_created_on = createdDate
        .split("to")[0]
        ?.trim()
        .split("-")
        .reverse()
        .join("-");
      let to_created_on = createdDate
        .split("to")[1]
        ?.trim()
        .split("-")
        .reverse()
        .join("-");

      const toFilter = {};
      if (filtersData.dateSubmit) {
        toFilter.from_created_on = from_created_on;
        toFilter.to_created_on = to_created_on;
      }
      setFilters({ ...filtersData, ...toFilter });
      setPage(1);
      onHide();
    } else {
      toast.error("Please fill out the fields");
      return;
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      backdropClassName="darkshadow"
      className="rounded-top mt-1"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <h3>Filter </h3>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="modall_body scrollBody">
        <div className=" filter-box pt-3  filterScroll">
          <div className="container-fluid">
            <div className="form-group my-2">
              <label htmlFor="tags" className="mb-2">
                Name
              </label>
              <input
                placeholder="Enter Name"
                value={filtersData?.name}
                onChange={(e) =>{
                  setFilterData({
                    ...filtersData,
                    name: e.target.value,
                  })
                }
                }
                type="text"
                className="form-control"
              />
            </div>
            <div className="form-group my-2">
              <label htmlFor="tags" className="mb-2">
                Email ID
              </label>
              <input
                placeholder="Enter E-mail"
                value={filtersData?.email}
                onChange={(e) =>
                  setFilterData({
                    ...filtersData,
                    email: e.target.value,
                  })
                }
                type="text"
                className="form-control"
              />
            </div>
            <div className="form-group my-2">
              <label htmlFor="tags" className="mb-2">
                Mobile Number
              </label>
              <input
                placeholder="Enter Mobile Number"
                maxLength={10}
                value={filtersData?.mobile_no}
                onFocus={(e) => {
                  setFilterData({
                    ...filtersData,
                    mobile_no: e.target.value,
                  });
                }}
                onChange={(e) =>
                  setFilterData({
                    ...filtersData,
                    mobile_no: e.target.value,
                  })
                }
                type="text"
                className="form-control"
              />
            </div>

            <div className="form-group my-2">
              <label htmlFor="tags" className="mb-2">
                Created On
              </label>
              <input
                value={
                  showDuedateRange
                    ? `${format(
                        filtersData.dueDateRange[0].startDate,
                        "dd-MM-yy"
                      )} to ${format(
                        filtersData.dueDateRange[0].endDate,
                        "dd-MM-yy"
                      )}`
                    : ""
                }
                placeholder="Select Created On Date Range"
                readOnly
                // className="inputBox"
                onClick={() => setOpenDueDateCalendar((open) => !open)}
                style={{
                  width: "100%",
                  height: "33px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  outline: "none",
                  padding: "5px 12px",
                }}
              />
              {openDueDateCalendar && (
                <DateRangeComponent
                  setOpenCalendar={setOpenDueDateCalendar}
                  openCalendar={openDueDateCalendar}
                  isDueDateComponent={true}
                  toBeFiltered={filtersData}
                  setToBeFiltered={setFilterData}
                  setShowReqDateRange={setShowReqDateRange}
                  setShowDuedateRange={setShowDuedateRange}
                />
              )}
            </div>
          </div>
        </div>

        <section className="pull-right m-4" 
        onKeyDown={() => applyFilter()}
        onClick={() => applyFilter()}
        >
          <a className="btn button_new_success p-3">Apply</a>
        </section>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ReferralPartnerFilter;
